/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const CandidateSourceDto = {
    CvSearch: 'CV_SEARCH',
    Erecruiter: 'ERECRUITER',
    KnowMe: 'KNOW_ME',
} as const;

export type CandidateSourceDto = typeof CandidateSourceDto[keyof typeof CandidateSourceDto];



